/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

/**
 * Список счетов для задачи по расписанию
 */
export interface ScheduleTaskAccount {
  /**
   * Номер счета
   * @example 40802810035500000149
   */
  accountNumber?: string;
}

/**
 * Параметры задачи по расписанию
 */
export interface ScheduleTaskRequest {
  /**
   * Период задачи
   * @example YESTERDAY
   */
  period?: "YESTERDAY";

  /**
   * Тип операции
   * @example CREDIT
   */
  operationType?: "ALL" | "DEBET" | "CREDIT";

  /**
   * Формат выписки
   * @example PDF
   */
  type?:
    | "PDF"
    | "XLS"
    | "ONE_C"
    | "ONE_C_101"
    | "ONE_C_102"
    | "CSV"
    | "PDF,XLS,ONE_C,ONE_C_101,ONE_C_102";

  /**
   * Направление сортировки по сумме
   * @example ASC
   */
  sortBySum?: "ASC" | "DESC";

  /**
   * Состав секций документа
   * @example WITH_DOCUMENTS
   */
  sections?: "WITH_DOCUMENTS" | "WITHOUT_DOCUMENTS" | "ONLY_DOCUMENTS";

  /**
   * Включить назначение платежа
   * @example true
   */
  itemDesc?: boolean;

  /**
   * С итогами по дням
   * @example false
   */
  dayTotal?: boolean;

  /**
   * Эквивалент в национальной валюте
   * @example true
   */
  national?: boolean;

  /**
   * Признак необходимости формирования архива (ZIP)
   * @example false
   */
  withoutZip?: boolean;

  /**
   * Признак формирования выписки в формате 1С (TXT) в один файл
   * @example true
   */
  allOneCStatementInOneFile?: boolean;

  /**
   * С подписью
   * @example false
   */
  withSig?: boolean;

  /** Фильтрация по тексту */
  textFiltration?: string;

  /** Список счетов */
  accounts?: ScheduleTaskAccount[];
}

export type EmptyResponse = object;

export interface ErrorMessage {
  /** Название ошибки */
  name?: string;

  /** Описание ошибки */
  description?: string;

  /** Дата и время возникновения ошибки */
  timestamp?: string;
}

/**
 * Параметры задачи по расписанию
 */
export interface ScheduleTask {
  /**
   * Id задачи
   * @format uuid
   * @example 1e0d630f-933f-4bee-b5dd-3ec68072d6b0
   */
  id?: string;

  /**
   * Статус задачи
   * @example NEW
   */
  status?: "NEW" | "WAITING" | "PROCESSING" | "ERROR";

  /**
   * Период задачи
   * @example YESTERDAY
   */
  period?: "YESTERDAY";

  /**
   * Тип операции
   * @example CREDIT
   */
  operationType?: "ALL" | "DEBET" | "CREDIT";

  /**
   * Формат выписки
   * @example PDF
   */
  type?:
    | "PDF"
    | "XLS"
    | "ONE_C"
    | "ONE_C_101"
    | "ONE_C_102"
    | "CSV"
    | "PDF,XLS,ONE_C,ONE_C_101,ONE_C_102";

  /**
   * Направление сортировки по сумме
   * @example ASC
   */
  sortBySum?: "ASC" | "DESC";

  /**
   * Состав секций документа
   * @example WITH_DOCUMENTS
   */
  sections?: "WITH_DOCUMENTS" | "WITHOUT_DOCUMENTS" | "ONLY_DOCUMENTS";

  /**
   * Включить назначение платежа
   * @example true
   */
  itemDesc?: boolean;

  /**
   * С итогами по дням
   * @example false
   */
  dayTotal?: boolean;

  /**
   * Эквивалент в национальной валюте
   * @example true
   */
  national?: boolean;

  /**
   * Признак необходимости формирования архива (ZIP)
   * @example false
   */
  withoutZip?: boolean;

  /**
   * Признак формирования выписки в формате 1С (TXT) в один файл
   * @example true
   */
  allOneCStatementInOneFile?: boolean;

  /**
   * С подписью
   * @example false
   */
  withSig?: boolean;

  /** Фильтрация по тексту */
  textFiltration?: string;

  /**
   * Время следующего запуска задачи
   * @format date-time
   */
  nextStartTs?: string;

  /** Последняя полученная ошибка */
  lastError?: string;

  /** Список счетов */
  accounts?: ScheduleTaskAccount[];
}

export interface PrintDocumentsRequest {
  /**
   * Идентификатор запроса выписки
   * @format uuid
   * @example 802bae02-9401-490d-a4c6-d76db8d642c6
   */
  requestId: string;

  /**
   * Список идентификаторов документов на печать
   * @example ["33434121223"]
   */
  documentIds: string[];
}

export interface BankStatementRequest {
  /**
   * Дата начала получения финансовой аналитики
   * @format date
   * @example 2022-01-01
   */
  fromDate: string;

  /**
   * Дата окончания получения финансовой аналитики
   * @format date
   * @example 2022-01-31
   */
  toDate: string;

  /**
   * Номер счета
   * @example ["40802810035500000149"]
   */
  accounts: string[];

  /**
   * С итогами по дням
   * @example true
   */
  dayTotal?: boolean;

  /**
   * ID организации
   * @example 802bae02-9401-490d-a4c6-d76db8d642c6
   */
  orgId?: string;

  /**
   * Выписка для УФЭБС
   * @example true
   */
  isUfebs?: boolean;

  /**
   * С итогами в национальной валюте
   * @example true
   */
  national?: boolean;

  /**
   * Включить назначение платежа
   * @example false
   */
  itemDesc?: boolean;

  /** Разделы выписки */
  sections?: ExtractSections;

  /**
   * Формат выписки
   * @example pdf
   */
  type?: "pdf" | "excel" | "1c" | "1c101";

  /**
   * Получить выписку в файле с подписью
   * @example false
   */
  withSig?: boolean;

  /**
   * Буквенные ISO-коды валют для запроса курса ЦБ на текущую дату
   * @example ["EUR"]
   */
  currencyRates?: string[];

  /**
   * Выгрузить выписку в родном формате, без использования архива (zip)
   * @example true
   */
  withoutZip?: boolean;

  /** Сортировка печатной формы выписки */
  fieldSorts?: FieldSorts;

  /** Поле для фильтрации по тексту */
  textFiltration?: string;

  /** Поместить все выписки по счетам в 1С формате в один файл */
  allOneCStatementInOneFile?: boolean;
  systemType?: "STATEMENT" | "RCK" | "HLD" | "MB";
}

/**
 * Разделы выписки
 * @example WITH_DOCUMENTS
 */
export enum ExtractSections {
  WITH_DOCUMENTS = "WITH_DOCUMENTS",
  WITHOUT_DOCUMENTS = "WITHOUT_DOCUMENTS",
  ONLY_DOCUMENTS = "ONLY_DOCUMENTS",
}

/**
 * Сортировка печатной формы выписки
 */
export interface FieldSorts {
  /** Типы параметров для сортировки */
  operationType?: SortParams;

  /** Типы параметров для сортировки */
  sum?: SortParams;
}

/**
 * Типы параметров для сортировки
 */
export enum SortParams {
  ASC = "ASC",
  DESC = "DESC",
  ALL = "ALL",
  DEBIT = "DEBIT",
  CREDIT = "CREDIT",
}

/**
 * Банк
 */
export interface Bank {
  /** Наименование банка */
  name?: string;

  /** Тип населенного пункта */
  placetype?: string;

  /** Наименование населенного пункта */
  placename?: string;

  /** БИК банка */
  bic?: string;

  /** Кор. счет банка */
  corAccount?: string;
}

export interface BankStatementResponse {
  /**
   * Дата начала получения финансовой аналитики
   * @format date
   * @example 2022-01-01
   */
  fromDate: string;

  /**
   * Дата окончания получения финансовой аналитики
   * @format date
   * @example 2022-01-31
   */
  toDate: string;

  /** Курсы ЦБ на текущую дату */
  currencyRates: CurrencyRate[];

  /** Выписки по счёту */
  items: ExtractItem[];
}

/**
 * Курсы ЦБ на текущую дату
 */
export interface CurrencyRate {
  /**
   * Дата курса ЦБ
   * @format date
   */
  date?: string;

  /** Буквенный ISO-код валюты */
  currencyISO?: string;

  /** Курс ЦБ валюты */
  currencyRateCB?: number;

  /** Динамика курса ЦБ */
  trend?: CurrencyRateTrend;
}

/**
 * Динамика курса ЦБ
 */
export enum CurrencyRateTrend {
  UP = "UP",
  DOWN = "DOWN",
  STABLE = "STABLE",
}

/**
 * Выписки по счёту
 */
export interface ExtractItem {
  /** Номер счета */
  account: string;

  /** Наименование счета, включая информацию о подопечных для номинальных счетов */
  accountName: string;

  /** Буквенный ISO-код валюты счёта */
  currency: string;

  /** Сумма оборотов по дебету в валюте счета */
  amountDb: number;

  /** Сумма оборотов по дебету в рублях */
  amountDbRub?: number;

  /** Сумма оборотов по кредиту в валюте счета */
  amountCr: number;

  /** Сумма оборотов по кредиту в рублях */
  amountCrRub?: number;

  /** Входящий остаток в валюте счета */
  begShDate: number;

  /** Входящий остаток в рублях */
  begShDateRub?: number;

  /** Исходящий остаток в валюте счета */
  endShDate: number;

  /** Исходящий остаток в рублях */
  endShDateRub?: number;

  /** Итоги по дням */
  dayTotal?: ExtractItemDayTotal[];

  /** Документы выписки */
  operations?: OperationDocument[];

  /**
   * Идентификатор запроса выписки
   * @format uuid
   */
  requestId?: string;
}

/**
 * Итоги по дням
 */
export interface ExtractItemDayTotal {
  /**
   * Дата, на которую предоставлена информация
   * @format date
   */
  balanceDate: string;

  /** Итого обороты за день по дебету в валюте счета */
  dayAmountDb: number;

  /** Итого обороты за день по дебету в рублях */
  dayAmountDbRub?: number;

  /** Итого обороты за день по кредиту в валюте счета */
  dayAmountCr: number;

  /** Итого обороты за день по кредиту в рублях */
  dayAmountCrRub?: number;

  /** Входящий остаток за день в валюте счета */
  dayBegShDate: number;

  /** Входящий остаток за день в рублях */
  dayBegShDateRub?: number;

  /** Исходящий остаток за день в валюте счета */
  dayEndShDate: number;

  /** Исходящий остаток за день в рублях */
  dayEndShDateRub?: number;

  /** Сумма операций за день (исх. ост. - вх. ост.) */
  operationResult?: number;

  /** Сумма операций за день в рублях (исх. ост. руб - вх. ост. руб) */
  operationResultRub?: number;
}

/**
 * Документы выписки
 */
export interface OperationDocument {
  /**
   * Дата операции
   * @format date
   */
  date: string;

  /** Описание операции или назначение */
  desc?: string;

  /** Сумма операции в валюте счета */
  amount: number;

  /** Сумма операции в рублях */
  amountRub?: number;

  /** Знак операции */
  sign: string;

  /** Номер документа */
  documentNumber?: string;

  /**
   * Дата документа
   * @format date
   */
  documentDate?: string;

  /** Код вида документа */
  kind?: string;

  /** Способ отправки */
  sendType?: string;

  /** Очередность */
  priority?: string;

  /** Статус отправителя 101 */
  taxPayerStatus?: string;

  /** КБК 104 */
  kbk?: string;

  /** ОКТМО 105 */
  oktmo?: string;

  /** Уникальный идентификатор начисления */
  uin?: string;

  /** Основание налогового платежа 106 */
  taxPaymentGround?: string;

  /** Налоговый период 107 */
  taxPeriod?: string;

  /** Номер налогового документа 108 */
  taxDocNumber?: string;

  /**
   * Дата налогового документа
   * @format date
   */
  taxDocDate?: string;

  /** Дата налогового документа */
  taxDocDateString?: string;

  /** Код вида дохода */
  incomeCode?: string;

  /** Данные о получателе */
  payer?: PaymentMember;

  /** Данные о получателе */
  receiver?: PaymentMember;

  /** Идентификатор платежного документа */
  documentId?: string;
}

/**
 * Данные о получателе
 */
export interface PaymentMember {
  /** Наименование субъекта */
  name: string;

  /** Номер счета */
  accountNumber: string;

  /** ИНН */
  inn: string;

  /** КПП */
  kpp: string;

  /** Банк */
  bank: Bank;
}

export interface FilterBankStatementRequest {
  /**
   * Дата начала получения финансовой аналитики
   * @format date
   * @example 2022-01-01
   */
  fromDate: string;

  /**
   * Дата окончания получения финансовой аналитики
   * @format date
   * @example 2022-01-31
   */
  toDate: string;

  /**
   * Номер счета
   * @example ["40802810035500000149"]
   */
  accounts: string[];

  /**
   * С итогами по дням
   * @example true
   */
  dayTotal?: boolean;

  /**
   * ID организации
   * @example 802bae02-9401-490d-a4c6-d76db8d642c6
   */
  orgId?: string;

  /**
   * Выписка для УФЭБС
   * @example true
   */
  isUfebs?: boolean;

  /**
   * С итогами в национальной валюте
   * @example true
   */
  national?: boolean;

  /**
   * Включить назначение платежа
   * @example false
   */
  itemDesc?: boolean;

  /** Разделы выписки */
  sections?: ExtractSections;

  /**
   * Формат выписки
   * @example pdf
   */
  type?: "pdf" | "excel" | "1c" | "1c101";

  /**
   * Получить выписку в файле с подписью
   * @example false
   */
  withSig?: boolean;

  /**
   * Буквенные ISO-коды валют для запроса курса ЦБ на текущую дату
   * @example ["EUR"]
   */
  currencyRates?: string[];

  /**
   * Выгрузить выписку в родном формате, без использования архива (zip)
   * @example true
   */
  withoutZip?: boolean;

  /** Сортировка печатной формы выписки */
  fieldSorts?: FieldSorts;

  /** Поле для фильтрации по тексту */
  textFiltration?: string;

  /** Поместить все выписки по счетам в 1С формате в один файл */
  allOneCStatementInOneFile?: boolean;
  systemType?: "STATEMENT" | "RCK" | "HLD" | "MB";

  /**
   * Минимальная сумма для документов выписки
   * @example 100.01
   */
  minSum?: number;

  /**
   * Максимальная сумма для документов выписки
   * @example 9999.99
   */
  maxSum?: number;

  /**
   * Фрагмент наименования/ИНН контрагента для документов выписки
   * @example Аэрофл
   */
  contragent?: string;

  /** Вид операции для документов выписки */
  operationType?: OperationType;
}

/**
 * Вид операции для документов выписки
 * @example DEBET
 */
export enum OperationType {
  ALL = "ALL",
  DEBET = "DEBET",
  CREDIT = "CREDIT",
}

export interface FilterBankStatementResponse {
  /**
   * Дата начала получения финансовой аналитики
   * @format date
   * @example 2022-01-01
   */
  fromDate: string;

  /**
   * Дата окончания получения финансовой аналитики
   * @format date
   * @example 2022-01-31
   */
  toDate: string;

  /** Курсы ЦБ на текущую дату */
  currencyRates: CurrencyRate[];

  /** Выписки по счёту */
  items: FilterExtractItem[];
}

/**
 * Выписки по счёту
 */
export interface FilterExtractItem {
  /** Номер счета */
  account: string;

  /** Наименование счета, включая информацию о подопечных для номинальных счетов */
  accountName: string;

  /** Буквенный ISO-код валюты счёта */
  currency: string;

  /** Сумма оборотов по дебету в валюте счета */
  amountDb: number;

  /** Сумма оборотов по дебету в рублях */
  amountDbRub?: number;

  /** Сумма оборотов по кредиту в валюте счета */
  amountCr: number;

  /** Сумма оборотов по кредиту в рублях */
  amountCrRub?: number;

  /** Входящий остаток в валюте счета */
  begShDate: number;

  /** Входящий остаток в рублях */
  begShDateRub?: number;

  /** Исходящий остаток в валюте счета */
  endShDate: number;

  /** Исходящий остаток в рублях */
  endShDateRub?: number;

  /** Итоги по дням */
  dayTotal?: ExtractItemDayTotal[];

  /** Документы выписки */
  operations?: OperationDocument[];

  /**
   * Идентификатор запроса выписки
   * @format uuid
   */
  requestId?: string;

  /**
   * Признак срабатывания фильтра для документов выписки
   * @example true
   */
  filterFired: boolean;
}

/**
 * Запрошенные отчёты выписки
 */
export interface StatementExportFile {
  /**
   * Идентификатор отчёта
   * @format uuid
   */
  id?: string;

  /**
   * Дата и время запроса выписки
   * @format date-time
   */
  requestDateTime?: string;

  /**
   * Дата и время готовности отчёта выписки
   * @format date-time
   */
  acceptedDateTime?: string;

  /** Наименование отчёта выписки */
  statementName?: string;

  /** Формат отчёта выписки */
  statementKind?: string;

  /** Статус отчёта выписки */
  stateCode?: string;
}

export interface FinancialAnalyticsRequest {
  /**
   * Дата начала получения финансовой аналитики
   * @format date
   * @example 2022-01-01
   */
  fromDate: string;

  /**
   * Дата окончания получения финансовой аналитики
   * @format date
   * @example 2022-01-31
   */
  toDate: string;

  /**
   * Номер счета
   * @pattern ^\d+$
   * @example 40702810935000001770
   */
  accountNumber: string;

  /** Период финансовой аналитики */
  periodType: PeriodType;
}

/**
 * Период финансовой аналитики
 * @example MONTH
 */
export enum PeriodType {
  MONTH = "MONTH",
  QUARTER = "QUARTER",
  YEAR = "YEAR",
  MANUAL = "MANUAL",
}

/**
 * Список дебетовых операций со счётом клиента за выбранный период
 */
export interface CompanyOperations {
  /** Наименование компании */
  companyTitle?: string;

  /** Операции компании */
  transactions?: OperationDocument[];

  /** Денежная сумма операций */
  amount?: number;
}

/**
 * Информация по периоду
 */
export interface DetailsInformation {
  /**
   * Дата начала периода
   * @format date
   */
  startDate?: string;

  /**
   * Дата окончания периода
   * @format date
   */
  endDate?: string;

  /** Расход */
  creditAmount?: number;

  /** Доход */
  debitAmount?: number;
}

export interface FinancialAnalyticsResponse {
  /** Расход */
  creditAmount?: number;

  /** Доход */
  debitAmount?: number;

  /** Входящий остаток по периоду */
  beginningPeriodAccountBalance?: number;

  /** Исходящий остаток по периоду */
  endingPeriodAccountBalance?: number;

  /** Информация по периоду */
  detailsInformationMap?: Record<string, DetailsInformation[]>;

  /** Список кредитовых операций со счётом клиента за выбранный период */
  operationDocuments?: Operation;
}

/**
 * Список кредитовых операций со счётом клиента за выбранный период
 */
export interface Operation {
  /** Список кредитовых операций со счётом клиента за выбранный период */
  credit?: CompanyOperations[];

  /** Список дебетовых операций со счётом клиента за выбранный период */
  debit?: CompanyOperations[];
}

/**
 * Тело запроса для экспорта отчета по бенефициарам
 */
export interface BeneficiarAccountExportRequest {
  /**
   * ID сессии формирования отчета
   * @format uuid
   * @example 802bae02-9401-490d-a4c6-d76db8d642c6
   */
  sessionId: string;

  /**
   * Формат файла выгрузки
   * @example XLS
   */
  fileFormat: "PDF" | "XLS" | "ONE_C" | "ONE_C_101" | "ONE_C_102" | "CSV";
}

/**
 * Статус счета для отчета по бенефициарам
 */
export interface BeneficiarAccountRecordStatus {
  /** Номер счета */
  number: string;

  /** Признак включения в отчет */
  statementOn: boolean;
}

/**
 * Тело запроса для сохранения отобранных счетов для отчета по бенефициарам
 */
export interface BeneficiarAccountSaveRequest {
  /**
   * ID сессии формирования отчета
   * @format uuid
   * @example 802bae02-9401-490d-a4c6-d76db8d642c6
   */
  sessionId: string;

  /** Отобранные пользователем для посстроения отчета счета */
  accounts?: BeneficiarAccountRecordStatus[];
}

/**
 * Тело ответа запроса с общей информацией для отчета по бенефициарам
 */
export interface BeneficiarAccountResponse {
  /**
   * ID сессии формирования отчета
   * @format uuid
   * @example 802bae02-9401-490d-a4c6-d76db8d642c6
   */
  sessionId: string;

  /**
   * Наименование клиента
   * @example Иванов И И
   */
  client: string;

  /**
   * ИНН клиента
   * @example 123456789012
   */
  inn: string;

  /**
   * Дата отчета
   * @format date-time
   */
  reportDate: string;

  /**
   * Дата начала отчета
   * @format date
   * @example 2022-01-01
   */
  fromDate: string;

  /**
   * Дата окончания отчета
   * @format date
   * @example 2022-01-31
   */
  toDate: string;

  /**
   * Включить в отчет только открытые счета
   * @example true
   */
  openAccount?: boolean;

  /**
   * Включить в отчет только закрытые счета
   * @example false
   */
  closeAccount?: boolean;

  /** Строки отчета со счетами */
  records?: BeneficiarAccountResponseRecord[];
}

/**
 * Тело ответа запроса с общей информацией по счетам для отчета по бенефициарам
 */
export interface BeneficiarAccountResponseRecord {
  /** Номер счета */
  number: string;

  /** ФИО бенефициара */
  fio: string;

  /** Входящий остаток на дату начала периода отчета */
  inBalance: number;

  /** Исходящий остаток на дату окончания периода отчета */
  outBalance: number;

  /** Обороты по дебету за период отчета */
  dbSum: number;

  /** Обороты по кредиту за период отчета */
  crSum: number;

  /**
   * Дата открытия счета
   * @format date
   * @example 2022-01-01
   */
  openDate: string;

  /**
   * Дата закрытия счета
   * @format date
   * @example 2022-01-31
   */
  closeDate: string;

  /** Признак включения в отчет */
  statementOn: boolean;
}

/**
 * Тело запроса на получение списка счетов для отчета по бенефициарам
 */
export interface BeneficiarAccountRequest {
  /**
   * ID сессии формирования отчета
   * @format uuid
   * @example 802bae02-9401-490d-a4c6-d76db8d642c6
   */
  sessionId: string;

  /**
   * Дата начала отчета
   * @format date
   * @example 2022-01-01
   */
  fromDate: string;

  /**
   * Дата окончания отчета
   * @format date
   * @example 2022-01-31
   */
  toDate: string;

  /**
   * Включить в отчет только открытые счета
   * @example true
   */
  openAccount?: boolean;

  /**
   * Включить в отчет только закрытые счета
   * @example false
   */
  closeAccount?: boolean;
}

/**
 * Ответ по запросам выписки с пагинацией
 */
export interface StatementExportFiles {
  list?: StatementExportFile[];

  /** Признак возможности запросить следующую страницу при таком же запросе */
  hasNext?: boolean;

  /**
   * Запрошенный размер
   * @format int32
   */
  size?: number;

  /**
   * Запрошенная страница
   * @format int32
   */
  page?: number;
}

export interface UserInfo {
  /** Имя пользователя */
  name?: string;

  /** ИНН пользователя */
  inn?: string;
}

export interface UserEmail {
  /** email пользователя */
  email?: string;
}

/**
 * Настройки микросервиса выписка
 */
export interface Settings {
  /**
   * Максимальное количество дней, которое может быть запрошено в выписке для отображения на экране
   * @format int32
   * @example 31
   */
  maxRangeDays?: number;

  /**
   * Глубина выписки, максимальное количество лет от текущей даты когда можно запросить выписку для формирования печатной формы
   * @format int32
   * @example 5
   */
  maxDepthYears?: number;

  /**
   * Максимальное количество дней, которое может быть запрошено в выписке для формирования печатной формы
   * @format int32
   * @example 31
   */
  maxRangeDaysForExport?: number;

  /**
   * Глубина выписки, максимальное количество лет от текущей даты когда можно запросить выписку для формирования печатной формы
   * @format int32
   * @example 5
   */
  maxDepthYearsForExport?: number;
}

export interface Account {
  name?: string;
  state?: string;
  isDefaultAccount?: boolean;
  isFavoriteAccount?: boolean;
  type?: string;
  number?: string;
  currency?: string;
  currentBalance?: number;
  wardInfo?: WardInfo;
}

export interface WardInfo {
  wardFirstName?: string;
  wardLastName?: string;
  wardMiddleName?: string;
}

export interface StatementExportFilesParams {
  /** @format int32 */
  page?: number;

  /** @format int32 */
  size?: number;
  systemType?: "STATEMENT" | "RCK" | "HLD" | "MB";
}

import { HttpClient } from "../../client";
import { ContentType, RequestParams } from "../../client/types";

/**
 * @title Микросервис statement
 * @version 1.0
 * @license Все права защищены ООО РСХБ-ИНТЕХ
 * @baseUrl https://owb-ms-prd-rko-statement.ndbo.dev.rshbdev.ru
 * @contact ООО РСХБ-ИНТЕХ, НДБО ЮЛ, Выписка операций по счёту <info@rshbintech.ru> (https://sdlc.go.rshbank.ru/confluence/pages/viewpage.action?pageId=44486754)
 */
export class Api<
  SecurityDataType extends unknown
> extends HttpClient<SecurityDataType> {
  api = {
    /**
     * No description
     *
     * @tags Выписка по расписанию
     * @name UpdateScheduleTask
     * @summary Редактирование задачи выписки по расписанию
     * @request PUT:/api/statement/v1/external/schedule-task/{id}
     * @secure
     */
    updateScheduleTask: (
      id: string,
      data: ScheduleTaskRequest,
      params: RequestParams = {}
    ) =>
      this.request<ScheduleTask, ErrorMessage | EmptyResponse>({
        path: `/api/statement/v1/external/schedule-task/${id}`,
        method: "PUT",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка по расписанию
     * @name DeleteScheduleTask
     * @summary Удалить задачу выписки по расписанию
     * @request DELETE:/api/statement/v1/external/schedule-task/{id}
     * @secure
     */
    deleteScheduleTask: (id: string, params: RequestParams = {}) =>
      this.request<void, ErrorMessage | EmptyResponse>({
        path: `/api/statement/v1/external/schedule-task/${id}`,
        method: "DELETE",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name PrintDocumentsPdf
     * @summary Печать платежных документов в формате PDF
     * @request POST:/api/statement/v2/external/bank-statement/print/documents
     * @secure
     */
    printDocumentsPdf: (
      data: PrintDocumentsRequest,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/print/documents`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name ExtractStatementV2
     * @summary Получение выписки операций по счёту для отображения на UI
     * @request POST:/api/statement/v2/external/bank-statement/extract
     * @secure
     */
    extractStatementV2: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<BankStatementResponse, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name ExtractStatementSendToEmailV2
     * @summary Экспорт выписки операций по счёту в файл и отправка на email
     * @request POST:/api/statement/v2/external/bank-statement/extract/send
     * @secure
     */
    extractStatementSendToEmailV2: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name FilterExtractStatement
     * @summary Получение выписки операций по счёту для отображения на UI (с фильтрацией)
     * @request POST:/api/statement/v2/external/bank-statement/extract/filter
     * @secure
     */
    filterExtractStatement: (
      data: FilterBankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<FilterBankStatementResponse, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract/filter`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name ExtractStatementExportV2
     * @summary Запрос формирования выписки операций по счёту в файл
     * @request POST:/api/statement/v2/external/bank-statement/extract/export
     * @secure
     */
    extractStatementExportV2: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<StatementExportFile, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name ExtractStatementExportV2Ufebs
     * @summary Запрос формирования УФЭБС выписки операций по счёту в файл
     * @request POST:/api/statement/v2/external/bank-statement/extract/export/ufebs
     * @secure
     */
    extractStatementExportV2Ufebs: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<StatementExportFile, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract/export/ufebs`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name ExtractStatementExportPdfV2
     * @summary Запрос формирования выписки операций по счёту в файл PDF
     * @request POST:/api/statement/v2/external/bank-statement/extract/export/pdf
     * @secure
     */
    extractStatementExportPdfV2: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<StatementExportFile, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract/export/pdf`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка по расписанию
     * @name CreateScheduleTask
     * @summary Сохранить задачу для выписки по расписанию
     * @request POST:/api/statement/v1/external/schedule-task
     * @secure
     */
    createScheduleTask: (
      data: ScheduleTaskRequest,
      params: RequestParams = {}
    ) =>
      this.request<ScheduleTask, ErrorMessage>({
        path: `/api/statement/v1/external/schedule-task`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Финансовая аналитика
     * @name GetFinancialAnalytics
     * @summary Получение финансовой аналитики по счёту
     * @request POST:/api/statement/v1/external/fin-analytics/get
     * @secure
     */
    getFinancialAnalytics: (
      data: FinancialAnalyticsRequest,
      params: RequestParams = {}
    ) =>
      this.request<FinancialAnalyticsResponse, ErrorMessage>({
        path: `/api/statement/v1/external/fin-analytics/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчетность по бенефициарам v1
     * @name SendEmail
     * @summary Экспорт отчета по бенефициарам в файл и отправка на email
     * @request POST:/api/statement/v1/external/beneficiar/send
     * @secure
     */
    sendEmail: (
      data: BeneficiarAccountExportRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/statement/v1/external/beneficiar/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчетность по бенефициарам v1
     * @name Download
     * @summary Экспорт отчета по бенефициарам в файл
     * @request POST:/api/statement/v1/external/beneficiar/download
     * @secure
     */
    download: (
      data: BeneficiarAccountExportRequest,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/statement/v1/external/beneficiar/download`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчетность по бенефициарам v1
     * @name SaveBeneficiarAccounts
     * @summary Сохоанение списка счетов отобранных для отчета
     * @request POST:/api/statement/v1/external/beneficiar/accounts/save
     * @secure
     */
    saveBeneficiarAccounts: (
      data: BeneficiarAccountSaveRequest,
      params: RequestParams = {}
    ) =>
      this.request<BeneficiarAccountResponse, ErrorMessage>({
        path: `/api/statement/v1/external/beneficiar/accounts/save`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Отчетность по бенефициарам v1
     * @name GetBeneficiarAccounts
     * @summary Получение списка счетов с оборотами для отображения на UI
     * @request POST:/api/statement/v1/external/beneficiar/accounts/get
     * @secure
     */
    getBeneficiarAccounts: (
      data: BeneficiarAccountRequest,
      params: RequestParams = {}
    ) =>
      this.request<BeneficiarAccountResponse, ErrorMessage>({
        path: `/api/statement/v1/external/beneficiar/accounts/get`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v1
     * @name ExtractStatement
     * @summary Получение выписки операций по счёту для отображения на UI
     * @request POST:/api/statement/v1/external/bank-statement/extract
     * @secure
     */
    extractStatement: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<BankStatementResponse, ErrorMessage>({
        path: `/api/statement/v1/external/bank-statement/extract`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v1
     * @name ExtractStatementSendToEmail
     * @summary Экспорт выписки операций по счёту в файл и отправка на email
     * @request POST:/api/statement/v1/external/bank-statement/extract/send
     * @secure
     */
    extractStatementSendToEmail: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<string, ErrorMessage>({
        path: `/api/statement/v1/external/bank-statement/extract/send`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v1
     * @name ExtractStatementExport
     * @summary Экспорт выписки операций по счёту в файл
     * @request POST:/api/statement/v1/external/bank-statement/extract/export
     * @secure
     */
    extractStatementExport: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/statement/v1/external/bank-statement/extract/export`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v1
     * @name ExtractStatementExportPdf
     * @summary Экспорт выписки операций по счёту в файл PDF
     * @request POST:/api/statement/v1/external/bank-statement/extract/export/pdf
     * @secure
     */
    extractStatementExportPdf: (
      data: BankStatementRequest,
      params: RequestParams = {}
    ) =>
      this.request<File, ErrorMessage>({
        path: `/api/statement/v1/external/bank-statement/extract/export/pdf`,
        method: "POST",
        body: data,
        secure: true,
        type: ContentType.Json,
        ...params,
      }),

    /**
     * @description Возвращает 200, если запись найдена, и 404, если запись не найдена.
     *
     * @tags Выписка операций по счёту v2
     * @name CheckExtractStatus
     * @summary Проверка статуса возможности формирования выписки
     * @request GET:/api/statement/v2/external/bank-statement/extract/export/ufebs/status
     * @secure
     */
    checkExtractStatus: (params: RequestParams = {}) =>
      this.request<EmptyResponse, EmptyResponse>({
        path: `/api/statement/v2/external/bank-statement/extract/export/ufebs/status`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name StatementExportFiles
     * @summary Получить сформированные файлы выписки операций по счёту
     * @request GET:/api/statement/v2/external/bank-statement/extract/export/files
     * @secure
     */
    statementExportFiles: (
      query: StatementExportFilesParams,
      params: RequestParams = {}
    ) =>
      this.request<StatementExportFiles, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract/export/files`,
        method: "GET",
        query: query,
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка операций по счёту v2
     * @name StatementExportFile
     * @summary Получить сформированный файл выписки операций по счёту
     * @request GET:/api/statement/v2/external/bank-statement/extract/export/files/{id}
     * @secure
     */
    statementExportFile: (id: string, params: RequestParams = {}) =>
      this.request<File, ErrorMessage>({
        path: `/api/statement/v2/external/bank-statement/extract/export/files/${id}`,
        method: "GET",
        secure: true,
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о пользователе
     * @name GetUserName
     * @summary Получить данные пользователя
     * @request GET:/api/statement/v1/external/user/info
     * @secure
     */
    getUserName: (params: RequestParams = {}) =>
      this.request<UserInfo, ErrorMessage | EmptyResponse>({
        path: `/api/statement/v1/external/user/info`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о пользователе
     * @name GetUserEmail
     * @summary Получить email пользователя
     * @request GET:/api/statement/v1/external/user/email
     * @secure
     */
    getUserEmail: (params: RequestParams = {}) =>
      this.request<UserEmail, ErrorMessage | EmptyResponse>({
        path: `/api/statement/v1/external/user/email`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Настройки МС
     * @name GetStatementSettings
     * @summary Получение настроек МС
     * @request GET:/api/statement/v1/external/settings
     * @secure
     */
    getStatementSettings: (params: RequestParams = {}) =>
      this.request<Settings, ErrorMessage | EmptyResponse>({
        path: `/api/statement/v1/external/settings`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Выписка по расписанию
     * @name GetScheduleTasks
     * @summary Получить список задач по расписанию
     * @request GET:/api/statement/v1/external/schedule-task/list
     * @secure
     */
    getScheduleTasks: (params: RequestParams = {}) =>
      this.request<ScheduleTask[], ErrorMessage>({
        path: `/api/statement/v1/external/schedule-task/list`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),

    /**
     * No description
     *
     * @tags Информация о счетах
     * @name GetClientAccounts
     * @summary Получить счета пользователя
     * @request GET:/api/statement/v1/external/account/accounts
     * @secure
     */
    getClientAccounts: (params: RequestParams = {}) =>
      this.request<Account[], ErrorMessage | EmptyResponse>({
        path: `/api/statement/v1/external/account/accounts`,
        method: "GET",
        secure: true,
        format: "json",
        ...params,
      }),
  };
}

export const api = new Api();
